import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    getNormativeArticles,
    loadNextNormativeArticlesChunk,
    loadNormativeArticles,
    loadNormativeDocumentsById
} from "../../redux/reducers/master-of-acts-reducer.js";
import {Handbook} from "../../components/Handbook/Handbook.jsx";

const LibrarySearchContainer = (props) => {
    const {
        open,
        onClose,
        normativeDocuments,
        referenceDescriptions,
        selectedHandbook,
        shadow,
        onCommitNormativeArticle
    } = props
    const [searchText, setSearchText] = useState('')
    const [timeOutId, setTimeOutId] = useState(undefined)
    const [isOpenFullNormativeArticleWindow, setIsOpenFullNormativeArticleWindow] = useState(false)
    const [selectedNormativeArticle, setSelectedNormativeArticle] = useState(null)

    const scrollRef = useRef()
    const normativeArticles = useSelector(getNormativeArticles)

    const normativeDocumentsIds = useMemo(() => normativeDocuments?.map(el => el.id), [normativeDocuments])
    const normativeDocumentsByIdKey = useMemo(() => normativeDocuments?.reduce((curr, value) => {
        curr[value.id] = value
        return curr
    }, {}), [normativeDocuments])
    const selectedDocument = useMemo(() => {
        if (selectedNormativeArticle) {
            for (const ref of referenceDescriptions) {
                if (ref.normative_document === selectedNormativeArticle.normative_document) {
                    return ref
                }
            }
        }
    }, [selectedNormativeArticle])

    const dispatch = useDispatch()

    const openFullNormativeArticleWindow = () => {
        setIsOpenFullNormativeArticleWindow(true)
    }

    const closeFullNormativeArticleWindow = () => {
        setSelectedNormativeArticle(null)
        setIsOpenFullNormativeArticleWindow(false)
    }

    const onNormativeArticleRowClick = (o) => () => {
        setSelectedNormativeArticle(o)
        openFullNormativeArticleWindow()
    }

    const handleSearchChange = (e) => {
        clearTimeout(timeOutId)
        setTimeOutId(setTimeout(async () => {
                await dispatch(loadNormativeArticles(normativeDocumentsIds, e.target.value))
                scrollRef.current.scrollTop = 0
            }, 425)
        )
        setSearchText(e.target.value)
    }

    const closeAll = () => {
        onClose()
        closeFullNormativeArticleWindow()
        setSearchText('')
    }

    const onNext = () => {
        if (normativeArticles.next) {
            dispatch(loadNextNormativeArticlesChunk(normativeDocumentsIds, searchText, normativeArticles?.next))
        }
    }

    useEffect(() => {
        if (referenceDescriptions) {
            dispatch(loadNormativeArticles(normativeDocumentsIds, ''))
        }
    }, [dispatch, referenceDescriptions, normativeDocuments])

    useEffect(() => {
        if (normativeDocumentsIds) {
            dispatch(loadNormativeDocumentsById(normativeDocumentsIds))
        }
    }, [normativeDocumentsIds])

    return <Handbook
        shadow={shadow}
        handbookName={selectedHandbook?.name}
        isOpenNormativeArticleDialog={open}
        closeNormativeArticleDialog={closeAll}
        searchText={searchText}
        handleSearchChange={handleSearchChange}
        normativeArticles={normativeArticles}
        onNext={onNext}
        closeAll={closeAll}
        onNormativeArticleRowClick={onNormativeArticleRowClick}
        isOpenFullNormativeArticleWindow={isOpenFullNormativeArticleWindow}
        closeFullNormativeArticleWindow={closeFullNormativeArticleWindow}
        selectedNormativeArticle={selectedNormativeArticle}
        scrollRef={scrollRef}
        selectedDocument={selectedDocument}
        normativeDocuments={normativeDocumentsByIdKey}
        onCommitNormativeArticle={onCommitNormativeArticle}
    />
};

export default LibrarySearchContainer;